import { Message, Modal, Text } from 'ui'
import { useCustomFieldsContext } from '../context/CustomFieldsProvider'

export const DeleteCustomFieldModal = () => {
  const {
    state: { deletingField, isDeleting, deleteErrorMessage },
    actions: { closeDelete, deleteField },
  } = useCustomFieldsContext()

  if (!deletingField) {
    return null
  }

  return (
    <Modal
      title="Delete tag"
      open
      onClose={closeDelete}
      showCancel
      onOk={deleteField}
      okText="Delete"
      loading={isDeleting}
    >
      <Text>
        Delete tag &ldquo;{deletingField.key}&rdquo;? This action cannot be
        undone.
      </Text>
      {deleteErrorMessage ? (
        <Message variant="error" mt={3}>
          {deleteErrorMessage}
        </Message>
      ) : null}
    </Modal>
  )
}
